import * as React from 'react';
import Notifications from '../components/Notifications';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import configData from "../config.json";
import { GetToken, GetSession } from '../components/Session';
import { DropDownList } from "@progress/kendo-react-dropdowns";

const InductionPlaylists = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState();
    const [lookupParams, setLookupParams] = React.useState("");
    const navigate = useNavigate();
    const subTotals = [];
    if (permissions && !permissions.CanView) navigate("/error401");
    const [layout, setLayout] = React.useState([
        { "field": "searchSite", "label": "Site", "isVisible": true, "type": "list" },
    ]);

    React.useEffect(() => {
        GetColumnDefs("InductionPlaylists", setColumns, setErrorMessage);
        GetPermissions(["ViewInductionPlaylists", "NewInductionPlaylists", "EditInductionPlaylists", "DeleteInductionPlaylists"], setPermissions)
        if (GetSession().SiteID === 1) {
            let baseUrl = configData.SERVER_URL + "apiv7/options";
            const init = {
                method: "GET",
                accept: "application/json",
                headers: { "Authorization": "Bearer " + GetToken() },
            };
            baseUrl = configData.SERVER_URL + "apiv7/options";
            fetch(baseUrl, init).then((response) => response.json()).then((d) => {

                setSites(CreateList(d.sites));
                setSite({ id: "0", name: "All" });
            });
        }
    }, [])

    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }
    const siteChanged = (event) => {
        setSite(event.target.value);
        if (event.target.value.id == "0")
            setLookupParams("");
        else
            setLookupParams(event.target.value.id);
    }

    const CreateList = (d) => {
        var x = [{ id: "0", name: "All" }, { id: "1", name: "Cloud (1)" }];
        d.map((v) => x.push({ id: v.id, name: v.name + " (" + v.id + ")" }));
        return x;
    }

    return (
        <div>
            <Notifications errorMessage={errorMessage} />
            <div className="row" style={{ padding: "5px 10px" }}>
                {GetField("searchSite")["isVisible"] && GetSession().SiteID === 1 && <div className="col-md-3">
                    <label className="control-label">{GetField("searchSite")["label"]}</label>
                    <DropDownList id="Site" data={sites} value={site} textField="name" dataItemKey="id" onChange={siteChanged} />
                </div>}
            </div>
            {columns && permissions && <DataGrid dataSource='apiv7/inductionplaylists' columns={columns} permissions={permissions} keyField="inductionPlaylistId" params={lookupParams} subTotals={subTotals} />}
        </div>
    );

}

export default InductionPlaylists;